const tracker = {
    expected: 0,
    settled: 0,
    mounted: false,
};

window.pdfRenderTracker = tracker;

export function expectPdfRender() {
    tracker.expected += 1;
}

export function settlePdfRender() {
    tracker.settled += 1;
}

export function markPdfRenderMountComplete() {
    tracker.mounted = true;
}

export default tracker;
